import { useState } from "react";
import PropTypes from "prop-types";
import IconButton from "@shared/v2/IconButton";
import Typography from "@shared/v2/Typography";
import { ChevronDownSolidV6 } from "@shared/v2/Icomoon";
import PanelCollapse from "@shared/v1/Panel/PanelCollapse";

const CollapsibleWebsiteCard = ({
  action,
  allowCollapse,
  children,
  className,
  disabled,
  panelClassName,
  title,
}) => {
  const [open, setOpen] = useState(true);

  return (
    <div className={`tw-min-w-[260px] tw-flex tw-flex-col ${className}`}>
      <div
        className={`tw-bg-[#fafafa] tw-rounded-t-[8px] tw-border-solid tw-border-[1px] tw-border-gray-10 ${allowCollapse ? "tw-pl-[10px]" : "tw-pl-[20px]"} tw-pr-[20px] tw-h-[48px] tw-flex tw-justify-between tw-items-center tw-gap-[24px]`}
      >
        <div className="tw-flex tw-items-center tw-gap-[4px]">
          {allowCollapse && (
            <IconButton schema="transparent" disabled={disabled} onClick={() => setOpen((o) => !o)}>
              <ChevronDownSolidV6
                className={`tw-transition-transform ${open && !disabled ? "" : "tw-rotate-180"}`}
              />
            </IconButton>
          )}
          <Typography variant="headline3">{title}</Typography>
        </div>
        {action}
      </div>
      <PanelCollapse
        allowCollapse={allowCollapse}
        transitionDuration={150}
        collapsed={!open || disabled}
        className={`tw-relative tw-bg-white tw-rounded-b-[8px] tw-border-solid tw-border-[1px] tw-border-t-0 tw-border-gray-10 ${panelClassName}`}
      >
        <div className="tw-px-[20px] tw-py-[24px]">{children}</div>
      </PanelCollapse>
    </div>
  );
};

CollapsibleWebsiteCard.propTypes = {
  action: PropTypes.node,
  allowCollapse: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  panelClassName: PropTypes.string,
  title: PropTypes.string.isRequired,
};

CollapsibleWebsiteCard.defaultProps = {
  action: null,
  allowCollapse: true,
  className: "",
  disabled: false,
  panelClassName: "",
};

export default CollapsibleWebsiteCard;
